import Vue from 'vue';
import Service from '@/config/service-identifiers';
import $services from '@/config/container';
import { AccessTokenKey, AUTH_STATE_COOKIE } from '@/store/auth/auth.store.constants';
import { getNewAuthRoute } from '@/auth/utils';
import { initialAbility } from "@/libs/acl/config";

export function getDomain() {
  const currentDomain = window.location.hostname;
  // console.log('currentDomain', currentDomain);
  let domain = currentDomain.split('.').splice(-2).join('.');
  // console.log('domain', domain);
  if (domain.startsWith('localhost:')) {
    domain = null;
  } 
  // else if (currentDomain.includes("nectios.com")) {
  //   domain = "nectios.com";
  // } else if (currentDomain.includes("intercontinentalalliance.com")) {
  //   domain = "intercontinentalalliance.com";
  // }
  // console.log('returning domain', domain);

  return domain;
}

export default {
  state: {
    token: null,
    user: null
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USER(state, user) {
      state.user = user;
    }
  },
  getters: {
    token() {
      return Vue.$cookies.get(AccessTokenKey);
    },
    isAuthenticated(_state, { token }) {
      return !!token;
    },
  },
  actions: {
    async login(_ctx, { email, password, communitySlug }) {
      const response = await $services[Service.BackendClient].post('login', {
        email,
        password,
        communitySlug,
      });
      
      const parentDomain = getDomain() ? `.${getDomain()}` : (process.env.VUE_APP_DOMAIN_1 || 'localhost');
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      
      Vue.$cookies.set(AccessTokenKey, response.data, {
        path: '/',
        domain: parentDomain,
        expires: date,
        secure: window.location.protocol === 'https:',
        sameSite: 'Lax'
      });
    },
    async loginsoap(_ctx, { user, password, communitySlug }) {
      const response = await $services[Service.BackendClient].post('login-soap', {
        user,
        password,
        communitySlug,
      });
      
      const parentDomain = getDomain() ? `.${getDomain()}` : (process.env.VUE_APP_DOMAIN_1 || 'localhost');
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      
      Vue.$cookies.set(AccessTokenKey, response.data, {
        path: '/',
        domain: parentDomain,
        expires: date,
        secure: window.location.protocol === 'https:',
        sameSite: 'Lax'
      });
    },
    async signup(_ctx, {
      email, communitySlug, referralType, referralID,
    }) {
      const response = await $services[Service.BackendClient].post('register-email', {
        email,
        communitySlug,
        referralType,
        referralID,
      });
      return response;
    },
    async register(_ctx, {
      email, password, name, lastname, timezone, phone, communitySlug, registrationToken, referralType, referralID, lang, country,
    }) {
      const response = await $services[Service.BackendClient].post('register', {
        email,
        password,
        name,
        lastname,
        phone,
        communitySlug,
        registrationToken,
        referralType,
        referralID,
        lang,
        country,
        timezone,
      });
      
      const parentDomain = getDomain() ? `.${getDomain()}` : (process.env.VUE_APP_DOMAIN_1 || 'localhost');
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      
      Vue.$cookies.set(AccessTokenKey, response.data, {
        path: '/',
        domain: parentDomain,
        expires: date,
        secure: window.location.protocol === 'https:',
        sameSite: 'Lax'
      });
      return response;
    },
    async password(_ctx, { email, communitySlug }) {
      const response = await $services[Service.BackendClient].post('password', {
        email,
        communitySlug,
      });
      return response;
    },
    async recoverPassword(_ctx, {
      password, repeatPassword, communitySlug, token,
    }) {
      const response = await $services[Service.BackendClient].post('password/recover', {
        password,
        repeatPassword,
        communitySlug,
        token,
      });
      return response;
    },
    async secureAuth(_ctx, { token }) {
      const response = await $services[Service.BackendClient].post('secureAuth', {
        secureToken: token,
      });
      
      const parentDomain = getDomain() ? `.${getDomain()}` : (process.env.VUE_APP_DOMAIN_1 || 'localhost');
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      
      Vue.$cookies.set(AccessTokenKey, response.data, {
        path: '/',
        domain: parentDomain,
        expires: date,
        secure: window.location.protocol === 'https:',
        sameSite: 'Lax'
      });
    },
    async googleAuth(_ctx, { code }) {
      const response = await $services[Service.BackendClient].post('googleauth', {
        code,
      });
      
      const parentDomain = getDomain() ? `.${getDomain()}` : (process.env.VUE_APP_DOMAIN_1 || 'localhost');
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      
      Vue.$cookies.set(AccessTokenKey, response.data, {
        path: '/',
        domain: parentDomain,
        expires: date,
        secure: window.location.protocol === 'https:',
        sameSite: 'Lax'
      });
    },
    async linkedinAuth(_ctx, { code }) {
      const response = await $services[Service.BackendClient].post('googleauth', {
        code,
        linkedin: true,
      });
      
      const parentDomain = getDomain() ? `.${getDomain()}` : (process.env.VUE_APP_DOMAIN_1 || 'localhost');
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      
      Vue.$cookies.set(AccessTokenKey, response.data, {
        path: '/',
        domain: parentDomain,
        expires: date,
        secure: window.location.protocol === 'https:',
        sameSite: 'Lax'
      });
    },
    async SSOAuth(_ctx, { code }) {
      const parentDomain = getDomain() ? `.${getDomain()}` : (process.env.VUE_APP_DOMAIN_1 || 'localhost');
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      
      Vue.$cookies.set(AccessTokenKey, code, {
        path: '/',
        domain: parentDomain,
        expires: date,
        secure: window.location.protocol === 'https:',
        sameSite: 'Lax'
      });
    },
    async logout({ commit, rootGetters }) {
      try {
        // Call auth service to clear HttpOnly cookies first
        await $services[Service.AuthClient].post('logout');
      } catch (error) {
        console.warn('Error calling logout endpoint:', error);
        // Continue with local cleanup even if backend call fails
      }

      // Reset user abilities/permissions first
      Vue.prototype.$ability?.update(initialAbility);
      
      commit('SET_TOKEN', null);
      commit('SET_USER', null);

      try {
        // Get all possible domains
        const domain1 = process.env.VUE_APP_DOMAIN_1 || 'localhost';
        const domain2 = process.env.VUE_APP_DOMAIN_2 || 'localhost';
        const currentDomain = window.location.hostname;
        const parentDomain = getDomain();
        
        // All possible domain variations to try
        const domainVariations = [
          domain1,
          domain2,
          currentDomain,
          parentDomain,
          parentDomain ? `.${parentDomain}` : null,
          'localhost',
          null, // Try without domain
          '/' // Root path
        ].filter(Boolean); // Remove null values
        
        // List of all security-related cookies to remove
        const cookiesToRemove = [
          AccessTokenKey,
          'token_signature',
          'XSRF-TOKEN',
          AUTH_STATE_COOKIE,
          'lastUrl',
          'registeredTo',
          'redirectTo',
          'auth_state',
        ];

        // Try to remove cookies with all possible domain/path combinations
        domainVariations.forEach(domain => {
          cookiesToRemove.forEach(cookieName => {
            try {
              // Try with explicit path and domain with secure and sameSite attributes
              Vue.$cookies.remove(cookieName, {
                path: '/',
                domain: domain,
                secure: true,
                sameSite: 'Strict'
              });
              
              // Also try with different sameSite values as they might have been set differently
              Vue.$cookies.remove(cookieName, {
                path: '/',
                domain: domain,
                secure: true,
                sameSite: 'Lax'
              });
              
              // Try with just basic options
              Vue.$cookies.remove(cookieName, '/', domain);
              Vue.$cookies.remove(cookieName, null, domain);
              Vue.$cookies.remove(cookieName, '/');
              Vue.$cookies.remove(cookieName);
            } catch (e) {
              console.warn(`Failed to remove cookie ${cookieName} from domain ${domain}:`, e);
            }
          });
        });
        
        // Clear all cookies that match our target names regardless of domain
        Vue.$cookies.keys().forEach(cookieName => {
          if (cookiesToRemove.some(target => cookieName.includes(target))) {
            Vue.$cookies.remove(cookieName);
          }
        });
        
        // Clear localStorage and sessionStorage
        localStorage.clear();
        sessionStorage.clear();
        
        // Determine which community to use for redirect
        const currentCommunity = rootGetters.currentCollective;
        const mainCommunity = rootGetters.mainCollective;
        const targetCommunity = mainCommunity?.key ? mainCommunity : currentCommunity;
        
        // If no community information is available, redirect to default auth
        if (!targetCommunity?.slug) {
          window.location.href = process.env.VUE_APP_MY_NECTIOS_URL;
          return Promise.resolve();
        }
        
        // Handle different environments
        if (process.env.VUE_APP_ENV !== "development") {
          const authRoute = getNewAuthRoute(targetCommunity);
          // console.log('logout() - authRoute', authRoute);
          window.location.href = authRoute;
          return Promise.resolve();
        }
        
        // Handle Nexos specific case
        const isNexos = process.env.VUE_APP_CUSTOMER === 'nexos' || targetCommunity?.key === 'f3166db0-b635-11ef-805d-f79ce25412de';
        if (isNexos) {
          const nexosAuthUrl = process.env.VUE_APP_AUTH + '/' + targetCommunity.slug;
          window.location.href = nexosAuthUrl;
          return Promise.resolve();
        }
        
        // Handle default case
        const loginUrl = `${process.env.VUE_APP_COMMUNITY_URL}/${targetCommunity.slug}/auth/login`;
        // console.log('logout() - loginUrl', loginUrl);
        
        window.location.href = loginUrl;
        
      } catch (error) {
        console.error('Error during logout:', error);
        // Fallback to basic logout if something goes wrong
        window.location.href = process.env.VUE_APP_MY_NECTIOS_URL;
      }
      
      return Promise.resolve();
    },
  },
};
